/* eslint-disable complexity */

import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import { List, ListItem } from '@unisporkal/alliance-ui';
import useSelectedIndex from '../../../hooks/stateful/useSelectedIndex.ts';
import useOnLoad from '../../../hooks/queries/useOnLoad';
import styles from './AssetOptions.module.scss';
import { getRfSubscriptionLabelKey } from '../../../shared/rfSubscriptionLabels.ts';

const AssetOptions = () => {
  const { response: { config: { options, optionTypes } = {} } = {} } =
    useOnLoad();
  const { setSelectedOptionIndex, selectedOption } = useSelectedIndex();
  const selectedOptionType = selectedOption?.type;
  const t = useTranslations();

  const getRoyaltyFreeSubscriptionLabel = (option) =>
    t(getRfSubscriptionLabelKey(option?.subFamily));

  const onSetSelectedOption = (optionType) => {
    if (selectedOptionType === optionType) return;

    const index = options.findIndex((option) => optionType === option.type);
    setSelectedOptionIndex(index);
  };

  const renderAssetOptionTabs = () => {
    const optionsLabelMap = {
      PremiumAccess: t('premium_access'),
      EasyAccess: t('easy_access'),
      ImagePack: t('ultrapack'),
      RoyaltyFreeSubscription: getRoyaltyFreeSubscriptionLabel(
        options?.find((o) => o.type === 'RoyaltyFreeSubscription')
      ),
      EditorialSubscription: t('subscription'),
      standardlicense: t('editorial_rights'),
      customlicense: t('custom_rights'),
    };

    return optionTypes.map((optionType) => (
      <ListItem
        className={styles.buyOption}
        key={optionType}
      >
        <input
          className={styles.buyOptionField}
          type="radio"
          value={optionType}
          id={optionType}
          data-testid={optionType}
          checked={selectedOptionType === optionType}
          onChange={() => onSetSelectedOption(optionType)}
        />
        <label
          className={`${styles.buyOptionLabel} ${
            selectedOptionType === optionType ? styles.selectedRedesign : ''
          }`}
          htmlFor={optionType}
        >
          {optionsLabelMap[optionType]}
        </label>
      </ListItem>
    ));
  };

  if (!optionTypes || optionTypes.length <= 1) {
    return null;
  }

  return (
    <List
      className={`${styles.buyOptions} ${styles.buyOptionsRedesign}`}
      data-testid="options"
    >
      {renderAssetOptionTabs()}
    </List>
  );
};

export default AssetOptions;
